<div class="bmc-view-delta__breadcrumb bz-color-border--neutral-300 bz-space--inset-s">
  <div class="breadcrumb__section">
    <span class="bz-space--inline-s breadcrumb__title" 
      [ngClass]="{ 'bz-font-weight--semibold': !selectedItemName, 'breadcrumb__title--inactive': selectedItemName }" 
      (click)="onTitleClick.emit()">
      {{ 'VIEW_DELTA.BREADCRUMB_TITLE' | translate }}
    </span>
    <bzg-icon *ngIf="selectedItemName" [nameIcon]="'icon-arrow-right-bold'" class="bz-space--inline-xs" [size]="12"></bzg-icon>
    <span *ngIf="selectedItemName" class="bz-space--inline-s bz-font-weight--semibold breadcrumb__selected-item">
      {{ selectedItemName }}
    </span>
  </div>
  <div class="breadcrumb__actions">
    <span *ngIf="!selectedItemName" class="breadcrumb__count">
      {{ selectedCount }} {{ 'VIEW_DELTA.ELEMENTS_SELECTED' | translate }}
    </span>
    <bzg-button-primary  
      *ngIf="!selectedItemName"
      [icon]="'icon-download'" 
      (click)="download()"
      [attr.title]="selectedCount === 0 ? ('VIEW_DELTA.DOWNLOAD_ALL_HINT' | translate) : ('VIEW_DELTA.DOWNLOAD_SELECTED_HINT' | translate)"
      [disabled]="isDownloading || selectedCount === 0">
      {{ isDownloading ? ("VIEW_DELTA.DOWNLOADING" | translate) : ("VIEW_DELTA.DOWNLOAD" | translate) }}
    </bzg-button-primary>
    <bzg-button-primary
      *ngIf="selectedItemName && hasDifferences"
      [icon]="'icon-compare'"
      (click)="viewDifferences()"
      class="breadcrumb__view-differences-btn">
      {{ 'VIEW_DELTA.COMPARE_CONTENT' | translate }}
    </bzg-button-primary>
  </div>
</div>
